import { images } from "./siteConfig";

export const solutionCategories = [
  { id: "daily-wellness", image: images.solutions.dailyWellness, sheetUrl: null, demo: true },
  { id: "energy-performance", image: images.solutions.energy, sheetUrl: null, demo: true },
  { id: "beauty-aging", image: images.solutions.beauty, sheetUrl: null, demo: true },
  { id: "sleep-relaxation", image: images.solutions.sleep, sheetUrl: null, demo: true },
  { id: "vitamins-functional", image: images.solutions.vitamins, sheetUrl: null, demo: true },
  { id: "custom-private-label", image: images.solutions.custom, sheetUrl: null, demo: true },
];
